import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Link } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    wrap: {
        width: '100%',
        padding: '5px',
        marginTop: '20px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    head: {
        backgroundColor: '#fff',
        border: '2px solid #000',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
        borderBottom: 'none',
    },
    parentTop: {
        display: 'flex',
    },
    parentBottom: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    childImage: {
        width: '30%',
        marginRight: '10px',
        marginLeft: '20px',
        position: 'relative'
    },
    personImage: {
        width:  '90px',
        verticalAlign: 'bottom',
        position: 'absolute',
        bottom: 0
    },
    childTitleWrap: {
        width: '60%',
        marginTop: '10px',
        marginRight: '10px'
    },
    childTitle: {
        marginTop: '10px',
        fontSize: '19px',
        fontWeight: 'bold',
        color: 'blue',
        textAlign: 'center'
    },
    childLine: {
        border: '1px solid #000',
        marginTop: '5px',
        marginBottom: '5px',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '90%',
        height: '1px'
    },
    child: {
        fontSize: '14px',
        paddingLeft: '3%',
        paddingRight: '3%'
    },
    childFooter: {
        paddingTop: '10px',
        paddingBottom: '5px',
        border: '2px solid #000',
        borderTop: 'none',
        borderBottomLeftRadius: '20px',
        borderBottomRightRadius: '20px',
        backgroundColor: '#C7DFC2',
    },
    childMobile: {
        width: '10%',
        marginRight: '10px',
    },
    mobileImage: {
        width: '35px',
        height: '47px',
    },
    childTel: {
        width: '60%',
        fontSize: '14px'
    },
    childTelString: {
        marginLeft: '15px'
    },
    childTelImage: {
    },
    childTime: {
        width: '18%',
        fontSize: '10px',
        textAlign: 'center'
    },
    childFaq: {
        width: '164px',
        marginLeft: '10px',
        marginRight: '5px'
    },
    childConfirm: {
        width: '164px',
        marginLeft: '5px',
        marginRight: '10px'
    },
    anchorWrap: {
        marginTop: '10px',
        marginBottom: '20px',
    },
    anchor: {
        fontSize: '18px',
        backgroundColor: 'skyblue'
    },
    attention: {
        fontSize: '10px',
        padding: '0.5em'
    }
}));

// 説明
function GuideHalf(props){
    const classes = useStyles();

    return(
        <div className={classes.wrap}>
            <div className={classes.head}>
                <div className={classes.childTitle}>
                    自筆証書遺言・財産目録の作成は弁護士に相談できます。
                </div>
            </div>
            <div className={classes.childFooter}>
                <div className={classes.parentBottom}>
                    <div className={classes.childMobile}>
                        <img src="img/mobile.png" className={classes.mobileImage} />
                    </div>
                    <div className={classes.childTel}>
                        <div className={classes.childTelString}>
                            お電話で弁護士へご相談はこちら
                        </div>
                        <div>
                            <img src="img/tel.png" className={classes.childTelImage} />
                        </div>
                    </div>
                    <div className={classes.childTime}>
                        <div>
                            受付時間
                        </div>
                        <div>
                            平日 10:00 〜 17:00<br/>
                            (年末年始除く)
                        </div>
                    </div>
                </div>
                <div className={classes.attention}>
                    ※お電話をいただく際「遺言相続コンサルティングのホームページを見ました」とお伝えいただくとスムーズにご案内致します。
                </div>
                <div className={classes.parentBottom}>
                    <div className={classes.childFaq}>
                        <a href="https://igon-sozoku.jp/qa/">
                            <img src="img/faq.png" />
                        </a>
                    </div>
                    <div className={classes.childConfirm}>
                        <a href="https://igon-sozoku.jp/inform/">
                            <img src="img/confirm.png" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GuideHalf
